import { BroadcastChannel } from 'broadcast-channel';

export const OKHandler = () => {
  const searchQuery = window.location.hash.replace('#', '?');
  const searchParams = new URLSearchParams(searchQuery);
  const accessToken = searchParams.get('access_token');
  const sessionSecretKey = searchParams.get('session_secret_key');
  const expiresIn = searchParams.get('expires_in');
  const chanel = new BroadcastChannel('auth-ok-code');

  if (accessToken) {
    chanel.postMessage({
      access_token: accessToken,
      session_secret_key: sessionSecretKey,
      expires_in: expiresIn,
      success: true,
    });
  } else {
    const error = {};
    searchParams.forEach((value, key) => {
      error[key] = value;
    });
    chanel.postMessage({
      success: false,
      error,
    });
  }
  setTimeout(() => {
    window.close();
  }, 250);
};
